import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useContext, useState, useEffect } from 'react'

import AppRoutes from './pages/AppRoutes'
import { loadingContext, validContext } from './lib'

import SplashScreen from './pages/SplashScreen'
import Login from './pages/Login'
import Page404 from './pages/Page404'
window.oncontextmenu = function () {
 
};
document.addEventListener("keypress", function(event){
  var key = event.key ;
  if (key === 'F12') {
      return false;
  } 
}, false);

document.addEventListener("keyup", function(event){
  var key = event.key ;
  if (key === 'F12') {
      return false;
  } 
}, false);

document.addEventListener("keydown", function(event){
  var key = event.key ;
  if (key === 'F12') {
      return false;
  }
}, false);


 

document.addEventListener("contextmenu",function(e){        
 
});

function App() {
  const [loading] = useContext(loadingContext)
  const [isValid] = useContext(validContext)


  var checkStatus;
var indicator = document.querySelector('#devtool-status');

  return (
    <>
      {loading && <SplashScreen />}
      <BrowserRouter>
        <Routes>
          {isValid && <Route path="/*" element={<AppRoutes />} />}
          {!isValid && <Route path="/" element={<Login />} />}
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default App
